class CookieConsent {
    constructor() {
        this.el = document.querySelector('[data-cookie-consent]');

        if (this.el) {
            this.el.querySelector('[data-cookie-consent-accept]').addEventListener('click', this.accept.bind(this));
        }

        this.show();
    }

    show() {
        if (!this.hasConsented()) {
            this.el.classList.remove('hidden');
        } else {
            this.el.remove();
        }
    }

    accept() {
        this.setCookie('cookie-consent', 'accepted', 365);
        this.el.style.display = 'none';
    }

    hasConsented() {
        return this.getCookie('cookie-consent') === 'accepted';
    }

    setCookie(name, value, days) {
        let expires = '';

        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = `; expires=${date.toUTCString()}`;
        }

        document.cookie = `${name}=${value || ''}${expires}; path=/`;
    }

    getCookie(name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];

            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }

            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }

        return null;
    }

    eraseCookie(name) {
        document.cookie = `${name}=; Max-Age=-99999999;`;
    }

    static init() {
        new CookieConsent;
    }
}

export default CookieConsent;
